<div class="ui container" appMargin appPadding paddingB="30">
  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutGap="20px" (click)="goBack()" class="link">
        <div>
          <img src="assets/icons/left-arrow-icon.svg" alt="" />
        </div>
        <div class="equipment-id">
          <!-- Title -->
          <label class="sub-item">Home / Settings </label>
          <h2 class="ui primary header" style="color: #3f4395">
            Chat Configuration
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div style="display: flex; margin-top: 24px">
    <div class="left_bar" style="flex: 4">
      <div class="top_left" appPadding="16px" paddingX="12px">
        <div
          class="column-header"
          fxLayout="row"
          fxLayoutGap="8px"
          fxLayoutAlign="start center"
          appPadding
          paddingY="16px"
        >
          <h2 class="ui large header">All Topics</h2>
        </div>

        <app-advanced-search-filter
          [placeholder]="'Search Topics'"
          (onSearch)="searchRecords($event)"
          [hasFilters]="true"
          [hasDisplayRows]="false"
          [hasSort]="false"
          [headerFilters]="headerFilters"
          [headers]="headers"
          [searchFilters]="searchFilter"
          appMargin
          marginY="16px"
          (advancedSearch)="advancedSearch($event)"
          (cancelAd)="cancelAd()"
        ></app-advanced-search-filter>

        <button
          appMargin
          [marginT]="'16px'"
          class="ui large primary button"
          (click)="addNewTopic()"
        >
          Add a new topic
        </button>
      </div>
      <div class="ui full divider"></div>

      <div *ngIf="success || error" appMargin marginY="10px">
        <esl-message-toast [(message)]="error"></esl-message-toast>
        <esl-message-toast
          [(message)]="success"
          [messageType]="'success'"
        ></esl-message-toast>
      </div>

      <div
        class="ui vertical basic segment lower-section"
        appPadding="0"
        [ngClass]="{ loading: pending }"
      >
        <!-- topics -->
        <div
          class="topics"
          appPadding
          paddingY="14px"
          paddingR="4px"
          *ngIf="topics && topics.length > 0"
        >
          <div *ngFor="let topic of topics">
            <app-chat-topic
              [topic]="topic"
              [activatedSubtopicId]="activatedSubtopicId"
              [activatedTopic]="activatedTopic?.topicId"
              (onActivate)="selectSubTopic($event, topic)"
              (onAdd)="addSubtopic(topic)"
              (onView)="viewTopic(topic)"
              (onEdit)="editTopic(topic)"
              (onDelete)="deleteTopic(topic)"
              (onRefresh)="refresh($event)"
              (assignSubtopicToUser)="assignSubtopicToUser($event)"
            ></app-chat-topic>
          </div>
        </div>

        <div class="empty-data-view" *ngIf="topics && topics.length < 1">
          <div class="content" fxLayout="column" fxLayoutAlign="center center">
            <img src="assets/images/empty-data.svg" alt="" />
            <div class="text">
              <h3 class="heading">
                This is where you’ll manage your chat topics and subtopics
              </h3>
              <p class="description">
                Click the Add a new topic button above to create topics for
                chats
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ui segment right_bar"
      style="flex: 8"
      [ngClass]="{ loading: assignedPending }"
    >
      <div *ngIf="selectedSubTopic && assignedUsers.length > 0">
        <div class="top_right">
          <div>
            <h3 class="ui header" style="text-transform: capitalize">
              Manage Users Assigned to {{ selectedSubTopic.subtopic }}
            </h3>
            <p>Topic: {{ selectedTopic.topic || selectedSubTopic.topic }}</p>
          </div>
          <div class="actions">
            <button
              class="ui basic primary button"
              [disabled]="!checkIfSelected()"
              (click)="deleteUsers(selectedSubTopic.subtopicId)"
            >
              Remove
            </button>
            <button (click)="updatePermissionUsers()" class="ui primary button">
              Save
            </button>
          </div>
        </div>
        <div class="ui divider"></div>
        <div appMargin marginY="16px" *ngFor="let user of assignedUsers">
          <div class="user">
            <div class="user_details"></div>
            <div class="read">READ</div>
            <div class="write">WRITE</div>
            <div class="watch">WATCH</div>
            <div class="delete">DELETE</div>
          </div>
          <div class="users">
            <div class="user">
              <div class="user_details">
                <sui-checkbox [(ngModel)]="user.selected"></sui-checkbox>
                <img
                  *ngIf="!user?.appUser.image"
                  src="../../../../../assets/avatar/1.jpg"
                  style="width: 60px; height: 60px; border-radius: 100%"
                />
                <img
                  *ngIf="user?.appUser.image"
                  src="{{ user?.appUser.image }}"
                  style="width: 60px; height: 60px; border-radius: 100%"
                />
                <div class="name">
                  <div class="ui tiny header">
                    {{
                      user?.appUser?.firstName || user?.appUser?.lastName
                        ? user?.appUser?.firstName +
                          " " +
                          user?.appUser?.lastName
                        : user?.appUser?.appUserEmail
                    }}
                  </div>

                  <div
                    class="ui tiny green circular label"
                    style="background: #44c4a1"
                    *ngIf="user?.appUser.active"
                  >
                    ACTIVE
                  </div>
                  <div
                    class="ui tiny green circular label"
                    style="background: red"
                    *ngIf="!user?.appUser.active"
                  >
                    INACTIVE
                  </div>
                </div>
              </div>
              <div class="read">
                <sui-checkbox [(ngModel)]="user.read"></sui-checkbox>
              </div>
              <div class="write">
                <sui-checkbox [(ngModel)]="user.write"></sui-checkbox>
              </div>
              <div class="watch">
                <sui-checkbox [(ngModel)]="user.watch"></sui-checkbox>
              </div>
              <div class="delete">
                <sui-checkbox [(ngModel)]="user.delete"></sui-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="!selectedSubTopic || assignedUsers.length === 0"
        class="ui vertical basic segment empty-data-view"
        appPadding="0"
        [ngClass]="{ loading: pending }"
      >
        <!-- chat messages -->
        <div class="content" fxLayout="column" fxLayoutAlign="center center">
          <img src="assets/images/empty-data.svg" alt="" />
          <div class="text">
            <h3 class="heading">
              Your Users' Screen is empty.
              <br />
              Start assigning user to see users screen
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
